import { render, staticRenderFns } from "./MagTeaserArticle.vue?vue&type=template&id=65ae8e7c&scoped=true"
import script from "./MagTeaserArticle.vue?vue&type=script&lang=js"
export * from "./MagTeaserArticle.vue?vue&type=script&lang=js"
import style0 from "./MagTeaserArticle.vue?vue&type=style&index=0&id=65ae8e7c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae8e7c",
  null
  
)

export default component.exports